const WHATSAPP_PHONE_TEXT_PATTERN = /wa\.me\/(\+?.*)\?text=(.*)/;

/**
 * Resolve o deeplink do whatsapp para o formato "whatsapp://send?phone=+5511999999999&text=olá"
 *
 * TIP: Em algum momento o Whatsapp alterou a maneira que o universal link "wa.me" resolve os deeplinks em dispositivos Android.
 * Antes era "wa.me" -> "whatsapp:". Depois foi para "wa.me" -> "intent://send"
 * Como nossa webview nativamente nao sabe lidar com esse novo formato, fizemos um replace para o formato antigo.
 *
 */
export const resolveWhatsAppDeepLink = (
  deeplink = '',
  replaceEnabled = false
) => {
  const whatsAppPhoneTextMatch = deeplink.match(WHATSAPP_PHONE_TEXT_PATTERN);

  if (!replaceEnabled || !whatsAppPhoneTextMatch) {
    return deeplink;
  }

  const [, phone, text] = whatsAppPhoneTextMatch;

  return `whatsapp://send?phone=${phone}&text=${text}`;
};
